import {Injectable} from '@angular/core';
import {GatewayRpcService, Namespace, Version} from "../gateway";
import {QueueActions, QueueItem, QueueType} from "./index";

@Injectable({
  providedIn: 'root'
})
export class QueueRpcService {
  queue: Queue;

  constructor(private rpc: GatewayRpcService) {
    this.queue = new Queue();
  }

  async enqueue(item: QueueItem){
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Queue,
          action: QueueActions.Enqueue,
          data: item
        });
    } catch (e) {
      return e;
    }
  }

  async pending(type: QueueType) {
    try {
      return await this.rpc.request(
        {
          version: Version.Base,
          namespace: Namespace.Queue,
          action: QueueActions.Pending,
          data: {type}
        });
    } catch (e) {
      return e;
    }
  }
}

export class Queue {

  queue: any[] = [];
  workingOnPromise = false;

  enqueue(promise: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject,
      });
      this.dequeue();
    });
  }

  dequeue() {
    if (this.workingOnPromise) {
      return false;
    }

    if (this.queue.length == 0) {
      this.workingOnPromise = false;
      return false;
    }

    const item = this.queue.shift();

    try {

      this.workingOnPromise = true;

      item.promise()
        .then((value: any) => {
          this.workingOnPromise = false;
          item.resolve(value);
          this.dequeue();
        })
        .catch((err: any) => {
          this.workingOnPromise = false;
          item.reject(err);
          this.dequeue();
        });

    } catch (err) {

      this.workingOnPromise = false;
      item.reject(err);
      this.dequeue();

    }

    return true;
  }

  static sleep(seconds: number) {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => resolve(true), seconds * 1000)
      } catch (e) {
        reject(e);
      }
    })
  }
}
